var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('transition',{attrs:{"name":"slide-fade","appear":""}},[_c('div',{staticClass:"modal-container"},[_vm._t("content")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }